import React, { useCallback, useEffect } from 'react';

import PropTypes from 'prop-types';

import ModalComponent from '@/components/common/Modal/ModalComponent';

const ModalContainer = ({ onClose, ...props }) => {
  const handleKeyUp = useCallback(
    evt => {
      if (evt.key === 'Escape') {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    document.addEventListener('keyup', handleKeyUp);
    const previousOverflow = document.body.style.overflow;
    // lock body scroll while modal is open
    try {
      document.body.style.overflow = 'hidden';
    } catch (e) {
      // ignore in environments where body is not writable
    }

    return () => {
      document.removeEventListener('keyup', handleKeyUp);
      try {
        document.body.style.overflow = previousOverflow || '';
      } catch (e) {
        // ignore
      }
    };
  }, [handleKeyUp]);

  return <ModalComponent handleClick={onClose} handleKeyUp={handleKeyUp} {...props} />;
};

ModalContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ModalContainer;
